module.exports = new __parcel__URL__("heros.d5da5dcf.svg").toString();